<template>
    <section class="padding-vertical-content lightgray-content mb-3 mb-lg-4" id="paso-3">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="padding-content white-content mb-2">
                        <b-card-text v-if="!esRenovacion || manager.documentacion_obligatoria_bases">
                            <p style="font-size: 19px;">{{ $t('bases.nueva_inscripcion') }}</p>
                            <ul>
                                <li style="font-size: 19px;"><b>{{ $t('bases.dni_jugador') }}</b></li>
                                <li style="font-size: 19px;"><b>{{ $t('bases.dni_responsables') }}</b></li>
                            </ul>
                            <p style="font-size: 19px;">{{ $t('bases.peso_imagenes', {peso: dropzoneOptions.maxFilesize}) }}</p>
                        </b-card-text>
                        <b-card-text v-else>
                            <h4>{{ $t('bases.imagenes_renovacion', {imagen: 'documentación' }) }}</h4>
                        </b-card-text>
                        <div v-if="base && base.documentos && base.documentos.length > 0">
                            <hr>
                            <h4 class="mt-2">{{ $t('bases.documentos_subidos') }}</h4>
                            <ul class="list-unstyled">
                                <template v-for="documento in base.documentos">
                                    <li class="h5" :key="documento.id">
                                        <a :href="documento.url" target="_blacnk" class="btn-link text-secondary"><i class="far fa-fw fa-image "></i> {{ documento.nombre }}</a>
                                        <button style="border: 0; background-color: white;" @click="showModal('borrar-' + documento.id)">&#10006;</button>
                                        <BorrarModalComponent
                                            :name="'borrar-' + documento.id"
                                            :title="'Borrar documento adjunto ' + documento.nombre"
                                            confirmButton="¿Está segur@ de borrar este documento?"
                                            v-on:close="() => closeModal()"
                                            v-on:confirm="() => borrarDocumento(documento.id)"
                                        >
                                        </BorrarModalComponent>
                                    </li>
                                </template>
                            </ul>
                        </div>
                        <vue-dropzone
                            ref="myVueDropzone" 
                            id="dropzone"
                            v-on:vdropzone-success="vdropzone_success_handler"
                            :options="dropzoneOptions"
                        >
                        </vue-dropzone>
                        <h4 style="font-size: 24px;" v-if="esRenovacion || !manager.documentacion_obligatoria_bases" class="mt-2 text-uppercase">{{ $t('bases.fotos_opcionales', {foto: 'documentación'}) }}</h4>
                        <div class="mt-3">
                            <button @click="terminar" name="button" :class="!esMovil ? 'button effect-button large-button' : 'button effect-button'" id="terminar-paso-3" :disabled="desactivar">
                                <span>{{ $t('formularios.continuar') }}</span>
                            </button>
                            <button @click="volver" name="button" :class="!esMovil ? 'button effect-button large-button ml-2' : 'button effect-button ml-2'" id="volver-paso-2" :disabled="!paso_activo" >
                                <span>{{ $t('formularios.atras') }}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import BorrarModalComponent from "@/components/backend/components/BorrarModalComponent";

export default {
    props: ["base", "paso_activo", "esMovil"],
    created() {
        this.dropzoneOptions["url"] = this.config.API_BASE + "/f/upload/documento" + "?tipo=bases&id=" + this.base["dni"];
    },
    data() {
        return {
            formulario: null,
            dropzoneOptions: {
                url: null,
                thumbnailWidth: 150,
                maxFilesize: 10,
                dictDefaultMessage: "Arrastra aquí la documentación",
            },
            documentos_id: [],
            esRenovacion: window.location.href.indexOf("renovar") > -1
        };
    },
    computed: {
        teatro() {
            return this.$store.getters.getTeatro;
        },
        configuracion() {
            return this.$store.getters.getConfig;
        },
        manager() {
            return this.$store.getters.getFooter;
        },
        desactivar() {
            if (!this.esRenovacion && this.manager.documentacion_obligatoria_bases) {
                if (!this.paso_activo || this.documentos_id.length == 0) {
                    return true;
                } else {
                    return false
                }
            } else {
                return false;
            }
        }
    },
    methods: {
        vdropzone_success_handler(file, response) {
            this.documentos_id.push(response.documento_id);
        },
        terminar() {
            if (this.base.documentos) {
                this.base.documentos.forEach(documento => {
                    this.documentos_id.push(documento.id);
                });
            }
            this.base.documentos_id = this.documentos_id;
            this.base.teatro_id = this.teatro.id;
            let params = {
                base: this.base,
                filters: {
                    tid: this.configuracion.hash_teatro,
                }
            }
            this.$store.dispatch(this.config.getVuexAlias('front.bases.guardar-datos-deportista'), params).then(res => {
                this.base.session_id = res.data.session_id;
            });
            this.$emit("terminado");
        },
        borrarDocumento(id) {
            this.base.documentos.splice(this.base.documentos.findIndex(function(i){
                return i.id === id;
            }), 1);
        },
        showModal(modal) {
            this.$modal.show(modal);
        },
        closeModal(modal) {
            this.$modal.hide(modal);
        },
        volver() {
            this.$emit('volver');
        },
    },
    components: {
        vueDropzone: vue2Dropzone, BorrarModalComponent
    },
};
</script>